import React, { useEffect } from 'react';
import { ParallaxLayer } from 'react-spring/renderprops-addons';
import useOnScreen from '../useOnScreen';
import image72 from '../assetsV2/72.png';
import image73 from '../assetsV2/73.png';
import anime from 'animejs';

import './InfluencerMarketing.scss';

const InfluencerMarketing = (props) => {
  const {
    pOffset, layoutFactor = 1, offsetAdjust = 0,
  } = props;
  const ref = React.createRef();
  const onScreen = useOnScreen(ref);

  const [debounce, setDebounce] = React.useState(false);

  useEffect(() => {
    if (!debounce && onScreen) {
      anime({
        targets: '.influencer-fade',
        opacity: [1, 0],
        translateY: 100,
        duration: 800,
        direction: 'reverse',
        easing: 'linear',
        delay: anime.stagger(60, { direction: 'reverse' }),
      });

      setDebounce(true);
    }
  }, [onScreen, debounce]);
  return (
    <>
      <ParallaxLayer
        offset={pOffset + offsetAdjust}
        factor={layoutFactor}
        speed={0}
        className="slide-i-container"
      >
        <div ref={ref} />
        <div className="influencer-fade brand-i-title cascade-fade-i ">Case Studies Influencer<br /> Marketing Solutions</div>
        <div className="brand-pic-row">
          <div className="pic-card">
            <a href="https://drive.google.com/file/d/1GdAxLHKsbAwcDKZF31W8mmog4L6gvXGO/view?usp=sharing" target="_blank" rel="noopener noreferrer">
              <img src={image72} alt="ARK: SURVIVAL EVOLVED" className="pic-2" loading="lazy" />
            </a>
            <div className="pic-caption">ARK: Survival Ascended</div>
          </div>
          <div className="pic-card">
            <a href="https://drive.google.com/file/d/1i_OxjqrWrDKYxy5vWFCeQUQUeKZydbx-/view" target="_blank" rel="noopener noreferrer">
              <img src={image73} alt="BELLWRIGHT" className="pic-2" loading="lazy" />
            </a>
            <div className="pic-caption">BELLWRIGHT</div>
          </div>
        </div>
      </ParallaxLayer>
    </>
  );
};

export default InfluencerMarketing;
